export default "__VITE_ASSET__2Z92DmeG__"